import { ChargePage } from './pages/charge/Page';
import { StudentManagementPage } from './pages/student-management/Page';
import { AdminPage } from './pages/admin/current';
import { PageSettingsPage } from './pages/page-settings/current';
import { PageSettingsV1Page } from './pages/page-settings/versions/v1/Page';
import { AdminV2Page } from './pages/admin/versions/v2/Page';
import { AdminV1Page } from './pages/admin/versions/v1/Page';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';

import { HandoffPage } from './pages/HandoffPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ComponentsPage } from './pages/ComponentsPage';
import { WelcomePage } from './pages/WelcomePage';
import { ModulePlaceholderPage } from './pages/ModulePlaceholderPage';
import { TeacherSchedulePage } from './pages/teacher-schedule/current';
import { TeacherScheduleV1Page } from './pages/teacher-schedule/versions/v1/Page';
import { ClassroomScheduleV2Page } from './pages/teacher-schedule/versions/v2/Page';
import { ClassroomScheduleV3Page } from './pages/teacher-schedule/versions/v3/Page';
import { CouponManagementPage } from './pages/coupon-management/current';
import { CouponManagementV1Page } from './pages/coupon-management/versions/v1/Page';
import { RecommendationCardManagementPage } from './pages/recommendation-card-management/current';
import { RecommendationCardManagementV1Page } from './pages/recommendation-card-management/versions/v1/Page';
import { IntentionStudentV1Page } from './pages/intention-student/versions/v1/Page';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<WelcomePage />} path="/" />
      <Route element={<ChargePage />} path="/modules/front-desk/收费" />
      <Route element={<StudentManagementPage />} path="/modules/front-desk/学员信息管理" />
      <Route element={<Navigate replace to="/modules/front-desk/收费" />} path="/quick-charge" />
      <Route element={<HandoffPage />} path="/handoff" />
      <Route element={<ProjectsPage />} path="/projects" />
      <Route element={<AdminPage />} path="/admin" />
      <Route element={<PageSettingsPage />} path="/page-settings" />
      <Route element={<PageSettingsV1Page />} path="/page-settings/v1" />
      <Route element={<AdminV1Page />} path="/admin/v1" />
      <Route element={<AdminV2Page />} path="/admin/v2" />
      <Route element={<ComponentsPage />} path="/components" />
      <Route element={<TeacherSchedulePage />} path="/teacher-schedule" />
      <Route element={<TeacherScheduleV1Page />} path="/teacher-schedule/v1" />
      <Route element={<ClassroomScheduleV2Page />} path="/teacher-schedule/v2" />
      <Route element={<ClassroomScheduleV3Page />} path="/teacher-schedule/v3" />
      <Route element={<CouponManagementPage />} path="/coupon-management" />
      <Route element={<CouponManagementV1Page />} path="/coupon-management/v1" />
      <Route element={<RecommendationCardManagementPage />} path="/recommendation-card-management" />
      <Route element={<RecommendationCardManagementV1Page />} path="/recommendation-card-management/v1" />
      <Route element={<IntentionStudentV1Page />} path="/intention-student" />
      <Route element={<ModulePlaceholderPage />} path="/modules/:moduleId/:menuLabel" />
      <Route element={<Navigate replace to="/" />} path="*" />
    </Routes>
  );
}

export function App() {
  return (
    <HashRouter>
      <AppRoutes />
    </HashRouter>
  );
}
